import styled from 'styled-components';

export const DraftHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const DraftHeaderMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ActionContainer = styled.div`
  display: flex;
  column-gap: 8px;
`;
